<template>
  <div class="ball" :class="{ small }" :style="ballStyle">
    {{ number }}
  </div>
</template>

<script>
export default {
  name: 'Ball',
  props: {
    number: {
      type: [Number, String],
      required: true
    },
    size: {
      type: String,
      default: 'normal',
      validator: (value) => ['small', 'normal', 'large'].includes(value)
    },
    color: {
      type: String,
      default: '#e95455'
    }
  },
  computed: {
    small () {
      return this.size === 'small'
    },
    ballStyle () {
      return {
        background: `linear-gradient(to bottom, ${this.color} 8%, ${this.darkenColor(this.color)} 100%)`
      }
    }
  },
  methods: {
    darkenColor (color) {
      const hex = color.replace('#', '')
      const r = parseInt(hex.substr(0, 2), 16)
      const g = parseInt(hex.substr(2, 2), 16)
      const b = parseInt(hex.substr(4, 2), 16)

      const darkenAmount = 0.2
      const darkenR = Math.floor(r * (1 - darkenAmount))
      const darkenG = Math.floor(g * (1 - darkenAmount))
      const darkenB = Math.floor(b * (1 - darkenAmount))

      return `#${darkenR.toString(16).padStart(2, '0')}${darkenG.toString(16).padStart(2, '0')}${darkenB.toString(16).padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>
.ball {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  box-shadow: 0 3px 5px rgba(0,0,0,0.1);
}

.ball.small {
  width: 35px;
  height: 35px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Ball.vue